import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {ORDER_HEADERS} from './orderHeaders'

export const useCreateOrderApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({expirationMinutes, currency}: Params.CreateOrder) => {
      const {data} = await ventrata.post<Ventrata.Order>(
        `/orders`,
        {
          expirationMinutes,
          currency,
        },
        {
          headers: ORDER_HEADERS,
        }
      )

      return data
    },
    [ventrata]
  )
}
